type OwnProps = {
  displayName?: string;
};

export default function Label({ displayName = '' }: OwnProps) {
  return (
    <div className="flex items-baseline gap-8">
      <span>{displayName}</span>
    </div>
  );
}
